<template lang="pug">
  #reset-password.xs-12
    .title.text-center
      p.xs-f-small.upper.xs-mt-100m.xs-mb-100m Signing In...

</template>

<script>
  import { mapState, mapMutations, mapActions } from 'vuex';
  import { verifyMagicLinkCipherStr } from "@services/vueCustomerSvc";

  export default {
    name: "LoginWithMagicLink",

    computed: {
      ...mapState('signIn', [
        'magicCode',
        'processing',
        'nextUrl',
        'userEmail'
      ]),
    },

    mounted() {
      this.setMagicCode(this.$route.query.magicCode);
      if (this.magicCode) {
        verifyMagicLinkCipherStr({ code: this.magicCode }).then(res => {
          this.setEmail(res.data.email);
          this.loginWithMagicLink().then(() => {
            this.trackSignInEvent(true);
          }).catch(() => {
            this.trackSignInEvent(false);
          });
        }).catch(() => {
          this.trackSignInEvent(false);
          this.notifyError("The link you’re trying to use has expired.");
          this.setView("signIn");
        });
      } else {
        this.notifyError("Uh oh, this link is invalid.");
        this.setView('signIn');
      }
    },

    methods: {
      ...mapActions([
        'notifyError'
      ]),
      ...mapActions('signIn', [
        'loginWithMagicLink'
      ]),

      ...mapMutations('signIn', [
        'setMagicCode',
        'setNextUrl',
        'setUserEmail',
        'setView',
      ]),

      setEmail(email) {
        return this.setUserEmail(email, null, { root: true });
      },

      trackSignInEvent(event) {
        event = event ? "Sign in - Logged in with magic link" : "Sign in - Invalid or expired magic link";
        this.trackMREvent(event, { email: this.userEmail });
      }
    },
  };
</script>

<style scoped lang="stylus">

</style>